var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("calls-report-table", {
        ref: "table",
        attrs: {
          url: _vm.indexUrl,
          "filter-list": _vm.filters,
          "download-url": _vm.downloadUrl,
          "can-download": _vm.canDownload,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }